export default {
  UNACCESSIBLE_SOURCE_LIST: ['EASA', 'CASA', 'SSO'],
  DOCUMENT_TYPES: {
    TEXT: 'text',
    HTML: 'html',
  },
};
